import { render } from "./ImagerySlider.vue?vue&type=template&id=d1dc5f34"
import script from "./ImagerySlider.vue?vue&type=script&lang=js"
export * from "./ImagerySlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__